import { render, staticRenderFns } from "./noidentyPop.vue?vue&type=template&id=3da8b3df&scoped=true&"
import script from "./noidentyPop.vue?vue&type=script&lang=js&"
export * from "./noidentyPop.vue?vue&type=script&lang=js&"
import style0 from "./noidentyPop.vue?vue&type=style&index=0&id=3da8b3df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8b3df",
  null
  
)

export default component.exports